export default "__VITE_ASSET__BNrr7YZN__"